export const useColor = () => {
    function getContrastColor(hexColor) {
        if (!hexColor) return null;

        let hex = hexColor.replace('#', '');

        if (hex.length === 3) {
            hex = hex
                .split('')
                .map((char) => char + char)
                .join('');
        }

        if (hex.length !== 6) return null;

        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        const yiq = (r * 299 + g * 587 + b * 114) / 1000;

        return yiq >= 128 ? '#000000' : '#FFFFFF';
    }

    return {
        getContrastColor,
    };
};
